<template>
    <div v-if="activeStepIndex > 0" class="wizzard">
        <template>
            <div
                :class="{
                    active: activeStepIndex === 1,
                    passed: isEditPage || activeStepIndex > 1,
                }"
            >
                Choose Files
            </div>
            <div
                :class="{
                    active: activeStepIndex === 2,
                    passed: isEditPage || activeStepIndex > 2,
                }"
            >
                Basic creation info
            </div>
            <div
                :class="{
                    active: activeStepIndex === 3,
                    passed: isEditPage || activeStepIndex > 3,
                }"
            >
                Screenshots / videos
            </div>
            <div
                :class="{
                    active: activeStepIndex === 4,
                    passed: isEditPage || activeStepIndex > 4,
                }"
            >
                Finish
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        activeStep: {
            type: String,
            default: '',
        },
        isEditPage: {
            type: Boolean,
        },
    },
    computed: {
        activeStepIndex() {
            switch (this.activeStep) {
                case 'binaryFileAndThumb':
                    return 1;
                case 'metaData':
                    return 2;
                case 'screenshots':
                    return 3;
                case 'finish':
                    return 4;
                default:
                    return -1;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$passed: #749aa6;
$active: #ffa306;
$light: #fff;
$grey-light: #e5e5e5;
$grey: #cbcbcb;

.wizzard {
    margin: 25px 0;
    display: flex;
    overflow: hidden;

    div {
        position: relative;
        padding: 0.5em 0;
        flex: 1 0 15%;
        text-align: center;
        background-color: $grey-light;

        &:not(:last-child) {
            &::before,
            &::after {
                content: '';

                position: absolute;
                z-index: 1;

                width: 0;
                height: 0;
            }

            &::before {
                $size: 19px;

                right: -21px; // ($size + 2px)
                top: -2px;

                border-top: $size solid transparent;
                border-bottom: $size solid transparent;

                border-left: $size solid $grey;
            }

            &::after {
                $size: 19px;

                right: -$size;
                top: -2px;

                border-top: $size solid transparent;
                border-bottom: $size solid transparent;

                border-left: $size solid $grey-light;
            }
        }

        &.passed {
            background-color: $passed;
            color: $light;

            &::after {
                border-left-color: $passed;
            }
        }

        &.active {
            background-color: $active;
            color: $light;

            &::after {
                border-left-color: $active;
            }
        }
    }
}
</style>
